/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationForNotifications {
    getFixupPrototypeFunction() { return ConfigurationForNotifications.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationForNotifications>): ConfigurationForNotifications {
        let obj = Object.assign(new ConfigurationForNotifications(), model);
        ConfigurationForNotifications.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationForNotifications>): ConfigurationForNotifications {
        if (!model) return null;
        return ConfigurationForNotifications.newInstance(<ConfigurationForNotifications> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationForNotifications) {
        if (!obj) return;

        models.ConfigurationForNotifications.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationForNotifications): boolean {
        Object.setPrototypeOf(obj, ConfigurationForNotifications.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Whether Notifications Are Enabled
     */
    enabled: boolean;

    /**
     * Emails
     */
    emails: Array<string>;

    /**
     * Webhooks
     */
    webhooks: Array<string>;

    /**
     * Microsoft Teams Webhooks
     */
    microsoft_teams_webhooks: Array<string>;

}
